export default "__VITE_ASSET__CyiImDdl__"